import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {PublishKeyMapper} from '../mappers/publish-key.mapper';

@Injectable({
    providedIn: 'root'
})
export class GetPublishKeyUseCase {
    constructor(
        private mapper: PublishKeyMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run() {
      return this.data.getPublishKey().pipe(this.mapper.map);
    }
}
